import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-login',
  templateUrl: './mobile-login.component.html',
  styleUrls: ['./mobile-login.component.scss']
})
export class MobileLoginComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
